<template>
    <div class="More">
        <navigation-bar Logo Bell v-if="this.$public.isCordova()"/>
        <div class="main">
            <user-info ref="userInfo"/>
            <div class="menu" v-if="isLogin">
                <el-row>
                    <el-col :xs="8" :sm="6" :md="4">
                        <router-link :to="{ name: 'MemberStore' }">
                            <img src="@/assets/images/more/join_store.svg" alt="入會店家">
                        </router-link>
                    </el-col>
                    <el-col :xs="8" :sm="6" :md="4">
                        <router-link :to="{ name: 'QrCode' }">
                            <img src="@/assets/images/more/qrcode.svg" alt="QR通訊錄">
                        </router-link>
                    </el-col>
                    <el-col :xs="8" :sm="6" :md="4" v-show="this.$public.isCordova()">
                        <router-link :to="{ name: 'Service' }">
                            <img src="@/assets/images/more/service.svg" alt="客服中心">
                        </router-link>
                    </el-col>
                    <el-col :xs="8" :sm="6" :md="4" v-show="this.$public.isCordova()">
                        <router-link :to="{ name: 'BookRecord', query: {'dataToken': bookRecordDataToken}}">
                            <!--todo 有新訂位狀態的小紅點-->
                            <div v-if="showDot" class="dot"/>
                            <img src="@/assets/images/more/booking.svg" alt="訂位狀態">
                        </router-link>
                    </el-col>
                    <el-col :xs="8" :sm="6" :md="4" v-show="this.$public.isCordova()">
                        <router-link :to="{ name: 'OrderRecordList' }">
                            <img src="@/assets/images/more/order.svg" alt="點餐紀錄">
                        </router-link>
                    </el-col>
                    <el-col :xs="8" :sm="6" :md="4">
                        <router-link :to="{ name: 'History' }">
                            <img src="@/assets/images/more/history.svg" alt="消費記錄">
                        </router-link>
                    </el-col>
                    <el-col :xs="8" :sm="6" :md="4" v-show="this.$public.isCordova()">
                        <div @click="openReserveRecordWeb">
                            <!--todo 小紅點-->
                            <div v-if="isReserveUnderway" class="dot"/>
                            <img src="@/assets/images/more/reservation.svg" alt="預訂紀錄">
                        </div>
                    </el-col>
                    <el-col :xs="8" :sm="6" :md="4">
                        <router-link :to="{ name: 'Form' }">
                            <img src="@/assets/images/more/form.svg"  alt="表單紀錄">
                        </router-link>
                    </el-col>
                    <el-col :xs="8" :sm="6" :md="4" v-show="this.$public.isCordova()">
                        <router-link :to="{ name: 'Feedback' }">
                            <!--todo 小紅點-->
                            <div v-if="showUnreadMsgDot" class="dot"/>
                            <img src="@/assets/images/more/feedback.svg" alt="意見反應">
                        </router-link>
                    </el-col>
                    <el-col :xs="8" :sm="6" :md="4" v-show="this.$public.isCordova()">
                        <router-link :to="{ name: 'Bulletin' }">
                            <img src="@/assets/images/more/news.svg" alt="公告快訊">
                        </router-link>
                    </el-col>
                    <el-col :xs="8" :sm="6" :md="4" v-if="false">
                        <router-link :to="{ name: 'AppSetting' }">
                            <img src="@/assets/images/more/settings.svg" alt="APP設定">
                        </router-link>
                    </el-col>
                    <el-col :xs="8" :sm="6" :md="4" v-if="this.$public.isCordova() && toOINPay !== ''">
                        <router-link :to="toOINPay">
                            <img src="@/assets/images/more/pay.svg"  alt="享樂遊錢包">
                        </router-link>
                    </el-col>
                    <el-col :xs="8" :sm="6" :md="4" v-if="false">
                        <router-link :to="{ name: 'TouchId' }">
                            <img src="@/assets/images/more/pay.svg"  alt="支付管理">
                        </router-link>
                    </el-col>
                    <el-col :xs="8" :sm="6" :md="4">
                        <router-link :to="{ name: 'Account'}">
                            <img src="@/assets/images/more/account.svg" alt="帳號設定">
                        </router-link>
                    </el-col>
                </el-row>
            </div>
            <div class="menu" v-if="!isLogin">
                <el-row>
                    <el-col :xs="8" :sm="6" :md="4" v-show="this.$public.isCordova()">
                        <router-link :to="{ name: 'Bulletin' }">
                            <img src="@/assets/images/more/news.svg" alt="公告快訊">
                        </router-link>
                    </el-col>
                    <el-col :xs="8" :sm="6" :md="4" v-show="this.$public.isCordova()">
                        <router-link :to="{ name: 'Service' }">
                            <img src="@/assets/images/more/service.svg" alt="客服中心">
                        </router-link>
                    </el-col>
                    <el-col :xs="8" :sm="6" :md="4">
                        <router-link :to="{ name: 'Account'}">
                            <img src="@/assets/images/more/account.svg" alt="帳號設定">
                        </router-link>
                    </el-col>
                </el-row>
            </div>
        </div>

        <comm-dialog :value="dialog.isShowDialog"
                     :outerContent="dialog.dialogMsg"
                     :isCancel="dialog.cancelable"
                     :positive-label="dialog.positiveLabel"
                     :is-text-box="dialog.isTextBox"
                     @result="onCommDialogClose" />

<!--        <comm-dialog v-bind="cDialog" @result="onCommDialogClose2"/>-->
        <loading
            :active.sync=isLoading
            :can-cancel="false"
            :is-full-page="true">
        </loading>
        <toast/>
    </div>
</template>

<script>
    import UserInfo from './components/UserInfo.vue';
    // import Logout from './components/Logout.vue';
    // import CommButton from "../../components/CommButton";
    import CommDialog from "@/components/CommDialog";
    import * as constDefine from '@/store/constDefine';
    import Toast from "@/components/Toast.vue";
    import * as mutationTypes from '@/store/mutationTypes';
    import {notNull} from "@/util/common";
    import {saveCryptoUserInfo} from "@/util/cryptoLocalStorage";

    export default {
        name: "More",
        components: { UserInfo,/* Logout,*/ CommDialog, Toast},
        data() {
            return {
                isLoading: false,
                btnName: 'Login',
                logoutDialog: false,
                isLogin: true,

                showDot:false,
                showUnreadMsgDot:false,         //是否顯示未讀意見的紅點?
                bookingQuantity:0,
                isReserveUnderway:false,        //尚有未到期的預訂資料
                // cDialog: {
                //     value: false,
                //     outerContent: '',
                //     mainContent: '',
                //     isCancel: false,
                // },

                dialog: {
                    isShowDialog: false,
                    dialogMsg: '',
                    cancelable: false,
                    positiveLabel: '確定',
                    isTextBox: false,
                },
                toOINPay: "",
                bookRecordDataToken: "",
            }
        },
        created() {
            if (this.$route.params.from !== undefined &&
                this.$route.params.message !== undefined &&
                this.$route.params.from === 'account') {
                this.dialog.isShowDialog = true;
                this.dialog.dialogMsg = this.$route.params.message;
            }

            this.bookRecordDataToken = this.$crypto.objectToURIComponent({
                usedType: 'BookRecord',
                storeId: 'allStore',
            })
        },
        mounted() {
            let self = this;
            this.isLogin = this.$auth.isAdminLogin(true);

            if (this.isLogin) {
                //如果有登入就取得個人資訊
                this.callGetUserInfoApi();
                this.getWhetherIsBooking();
                this.callIsUnreadFeedbackApi();
            }

            //監聽 newLogin 事件
            this.$root.$on('newLogin', (newLogin) => {
                //新登入
                if (newLogin) {
                    self.callGetUserInfoApi();
                }
            });

        },
        beforeDestroy() {
            this.$root.$off('newLogin');
        },
        methods: {
            getWhetherIsBooking:function(){
                let self = this
                self.$http.fetchWithAuth`GetUserWhetherIsBooking${{
                }} ${json => {
                    self.bookingQuantity = parseInt(json.data.dataQuantity)
                    if(self.bookingQuantity>0){
                        self.showDot = true
                    }else{
                        self.showDot = false
                    }
                }}`;
            },
            // /** 顯示訊息 dialog */
            // showDialog2: function (title, msg, cancelable = false) {
            //     this.cDialog.value = true;
            //     this.cDialog.outerContent = title;
            //     this.cDialog.mainContent = msg;
            //     this.cDialog.isCancel = cancelable;
            // },
            //
            // /** CommDialog 關閉事件 */
            // onCommDialogClose2(result) {
            //     this.cDialog.value = false;
            // },

            /** CommDialog 關閉事件 */
            onCommDialogClose(result) {
                this.dialog.isShowDialog = false;
            },

            /** 取得個人資訊 */
            callGetUserInfoApi: function () {
                this.isLoading = true;

                this.$http.fetchWithAuth`GetUserInfoWithId${{

                }} ${json => {
                    this.isLoading = false;

                    if (notNull(json.data)) {
                        this.saveUserData(json.data);
                        let isHaveToken = json.data.isHaveToken;
                        let isHavePayPassword = json.data.isHavePayPassword;
                        if (json.data.isHaveOINPay) {
                            if (!isHaveToken && !isHavePayPassword) {
                                this.toOINPay = {name: 'OINPay'}
                            } else {
                                let routerName = "PayPassword"
                                let dataToken = this.$crypto.objectToURIComponent({
                                    usedType: routerName,
                                    isHavePayPassword: isHavePayPassword,
                                    successRouterName: "OINPay",
                                })

                                this.toOINPay = {name: routerName, query: {'dataToken': dataToken}}
                            }
                        }
                    }
                }}`;
            },

            /** 是否有未讀的意見回覆 */
            callIsUnreadFeedbackApi : function() {
                let self = this
                return new Promise(function(resolve, reject) {
                    self.$http.fetchWithAuth`GetIsUnreadFeedback${{
                    }} ${json => {
                        if (self.$public.notNull(json.data)) {
                            self.showUnreadMsgDot = json.data.isUnread;
                            //console.log(`confirmBookingUrl : ${self.confirmBookingUrl}`);
                        }

                        //完畢
                        resolve();
                    }}`;
                });
            },

            /** 暫存 userInfo */
            saveUserData: function (userInfo) {
                if (notNull(userInfo)) {
                    this.isReserveUnderway = userInfo.isReserveUnderway;
                    // localStorage.setItem('userInfo', JSON.stringify(userInfo));
                    saveCryptoUserInfo(userInfo);
                    this.$root.$emit('isLogout', false);
                }
            },

            /** 打開預定紀錄網頁 */
            openReserveRecordWeb() {
              let dataToken = this.$crypto.objectToURIComponent({
                usedType:    "openReserveRecordWeb",
                userToken:   this.$auth.getAdminToken(),
                isCordova:   this.$public.isCordova(),
              })

              let urlSet = process.env.VUE_APP_RESERVE_HOST + "/record?dataToken=" +dataToken;
              this.$public.openUrlWithCloseBtn(urlSet);
            }
        }
    }
</script>

<style lang="less" scoped src="../../less/more.less"/>